(($, Drupal) => {
  $(setTimeout( function() {
      let countryJumpMenu;
      if ($(".legality-hero select.select-country").length > 0) {
        countryJumpMenu = $(".legality-hero select.select-country").clone();
        $(".country-jump-menu").append(countryJumpMenu);
        $("select.select-country option:first-child").prop("disabled", "true");
        $("select.select-country").on("change", function onChange() {
          let nodeId = $(this).val(); // get selected value
          if (!nodeId) {
            return;
          }
          if (nodeId === "other") {
            nodeId = 115231; // Other Countries Node ID
          }
          window.location =
            $("html").attr("lang") === "en"
              ? `/node/${nodeId}`
              : `/${$("html").attr("lang")}/node/${nodeId}`;
        });
      } else if ($(".grr-hero select.select-country").length > 0) {
        countryJumpMenu = $(".grr-hero select.select-country").clone();
        $(".country-dropdown-menu").append(countryJumpMenu);
        $("select.select-country option:first-child").prop("disabled", "true");
        $("select.select-country").on("change", function onChange() {
          const nodeId = $(this).val(); // get selected value
          if (!nodeId) {
            return;
          }
          window.location =
            $("html").attr("lang") === "en" ? `/node/${nodeId}` : `/${$("html").attr("lang")}/node/${nodeId}`;
        });
      }
    }),
    1
  );
})(jQuery, Drupal);
